/* ----------------- Helpers --------------- */
import { isWeb } from "@helpers/platform";
import type {
	Media,
	OriginalItemTypes,
} from "@memorang/types/src/session/new-session";

import { useDevice } from "@hooks/useDevice";
import Box from "@memorang/ui/src/components/Box";
import ImagesCarousel from "@memorang/ui/src/components/ImagesCarousel";
import { VideoPlayer } from "@memorang/ui/src/components/VideoPlayer";
import { Caption } from "react-native-paper";
import AudioPlayerContainer from "../containers/AudioPlayerContainer";
/* ----------------- Child Components --------------- */
import ItemStem from "./ItemStem";

interface Props {
	stem: string;
	itemId: number;
	showTTS?: boolean;
	highlightedHtml?: string;
	video?: string;
	handleStoreHtml?: (html: string) => void;
	audio?: string;
	isSummativeTest?: boolean;
	handleHighlightedTextPress?: () => void;
	instructions?: string;
	originalItemType?: OriginalItemTypes;
	images?: Media[];
}
export const StemContainer = ({
	stem,
	itemId,
	showTTS,
	highlightedHtml,
	video,
	handleStoreHtml,
	audio,
	isSummativeTest,
	handleHighlightedTextPress,
	instructions,
	originalItemType,
	images,
}: Props) => {
	const { isMobile } = useDevice();

	const shouldShowAudioPlayer =
		audio && originalItemType === "LISTENING_REPLAY";
	return (
		<Box
			paddingHorizontal={isWeb && !isMobile ? 0 : 16}
			gap={16}
			accessibilityLabel={`question. ${stem}`}
		>
			{stem && (
				<Box gap={16}>
					<ItemStem
						text={stem}
						highlightedHtml={highlightedHtml}
						handleStoreHtml={handleStoreHtml}
						isSummativeTest={isSummativeTest}
						itemId={itemId}
						showTTS={showTTS}
						handleHighlightedTextPress={handleHighlightedTextPress}
					/>
					{images && images.length > 0 && (
						<ImagesCarousel
							images={images}
							contentFit="contain"
							containerStyle={
								isSummativeTest
									? {
											justifyContent: "flex-start",
											alignItems: "flex-start",
										}
									: undefined
							}
						/>
					)}
					{shouldShowAudioPlayer && (
						<AudioPlayerContainer uri={audio} itemId={itemId} />
					)}
					{instructions && (
						<Caption style={{ marginTop: 8 }}>{instructions}</Caption>
					)}
				</Box>
			)}
			{video && <VideoPlayer videoUrl={video} />}
		</Box>
	);
};
